import React from 'react';
import PropTypes from 'prop-types';

import { Seo, SiteLayout } from '@fundera/fundera-design-system';

import PageHeader from '../../components/PageHeader';

const NotFoundPage = ({ location }) => (
  <SiteLayout location={{ location }} header={<PageHeader />}>
    <Seo title="404: Not found" />
    <section className="not-found-information Content-wrapper">
      <div className="container inner-container">
        <h1>NOT FOUND</h1>
        <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
      </div>
    </section>
  </SiteLayout>
);

NotFoundPage.propTypes = {
  location: PropTypes.string.isRequired,
};

export default NotFoundPage;
